import { query } from '../../network/fetch.js'
import * as queries from '../../network/queries/users'
import { LOGIN } from '../types'

const state = {
    isFetching: false,
    per_page: 25,
    total: 0
}

const actions = {

    switchUser ({ commit }, id) {

        return new Promise((resolve) => {
            query({
                query: queries.switchUser,
                variables: {
                    user_id: id
                }
            }).then( ({ data }) => {
                const tokens = data.switchUser
                commit(LOGIN, {
                    token: tokens.access_token,
                    searchToken: tokens.search_token
                })
                location.reload()

                resolve()
            })
        })
    }
}

export default {
    state,
    actions
}
